import { StyleSheet } from 'aphrodite';
import { THEME } from '@Theme';
import { overviewFieldValueTypography } from './overviewFieldStyles';

/**
 * Styling for the read-mode Next Meeting trigger. It has to read as a field value first and an
 * affordance second, so it takes the field value typography and only borrows the color/underline
 * from the `link` button variant. `inline-flex` keeps the click target on the date itself — the
 * `Button` base is `display: flex`, which would stretch it across the field's whole grid column.
 */
export const accountNextMeetingFieldStyles = StyleSheet.create({
	trigger: {
		...overviewFieldValueTypography,
		color: THEME.colors.primary.main,
		display: 'inline-flex',
		fontWeight: THEME.typography.fontWeights.standard,
		height: 'auto',
		padding: 0,
		textDecoration: 'none',
	},
});
